// docs-feed 호출 — 원고를 admin 「레이블리 가이드」 표(lay_docs_guide)에서 읽는다.
// 서버 계약은 server/docs-feed/README.md.
//
// REACT_APP_DOCS_FEED_URL 이 있을 때만 켜진다. 없으면 사이트는 예전처럼 public/content/*.md 를 읽는다
// (docs/DocsContext.jsx 가 두 모드를 가른다). 프리뷰(단일 파일) 빌드는 외부 fetch 가 막혀 있어 항상 정적이다.
//
// 캐시: 같은 authKey(로그인 사용자 또는 'anon') 안에서 list/bundle/doc 응답을 메모리에 둔다.
// 문서를 오갈 때마다 왕복하지 않게 하려는 것이고, 로그인·로그아웃으로 authKey 가 바뀌면 자연히 비워진다.

export const FEED_URL = (process.env.REACT_APP_DOCS_FEED_URL || '').replace(/\/+$/, '');
export const feedEnabled = Boolean(FEED_URL) && process.env.REACT_APP_PREVIEW !== '1';

const CACHE_TTL_MS = 60 * 1000;
const cache = new Map(); // key -> { at, promise }

export function clearFeedCache() {
  cache.clear();
}

export class FeedError extends Error {
  constructor(status, code, data) {
    super(code || `feed_${status}`);
    this.name = 'FeedError';
    this.status = status;
    this.code = code;
    this.data = data || null;
  }
}

async function call(path, token) {
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  let res;
  try {
    // cache: 'no-store' — 비로그인으로 받은 /list 를 브라우저 HTTP 캐시가 로그인 뒤 요청에 재사용해
    // 공개 문서만 보이던 문제(2026-09-06). 캐시는 위의 메모리 캐시만 쓴다.
    res = await fetch(`${FEED_URL}/${path}`, { headers, cache: 'no-store' });
  } catch (e) {
    throw new FeedError(0, 'network');
  }
  let data = null;
  try { data = await res.json(); } catch (e) { data = null; }
  if (!res.ok) throw new FeedError(res.status, data?.error || null, data);
  return data;
}

function cached(key, token, path) {
  const hit = cache.get(key);
  if (hit && Date.now() - hit.at < CACHE_TTL_MS) return hit.promise;
  const promise = call(path, token).catch((e) => { cache.delete(key); throw e; });
  cache.set(key, { at: Date.now(), promise });
  return promise;
}

// { scope, signed_in, generated_at, pages: [{ slug, title, group, audience, position, updated_at, visible }] }
export function fetchList(token, authKey) {
  return cached(`list|${authKey}`, token, 'list');
}

// { slug, title, group, audience, position, updated_at, body }
export function fetchDoc(slug, token, authKey) {
  return cached(`doc|${authKey}|${slug}`, token, `doc?slug=${encodeURIComponent(slug)}`);
}

// { scope, signed_in, generated_at, pages: [ …list 항목 + body ] }
export function fetchBundle(token, authKey) {
  return cached(`bundle|${authKey}`, token, 'bundle');
}
